import { Group, Stack } from '@mantine/core';
import { useSuspenseApiAdminGetRunningAutomations } from '@repo/api-codegen';
import { Button, Text } from '@repo/foundations';
import AutomationCard from './AutomationCard';

function AdminAutomationsPage() {
	const { data, isLoading, refetch } = useSuspenseApiAdminGetRunningAutomations(
		{}
	);

	const automations = data?.latest_in_queue || [];
	const totalAutomations = data?.total || 0;

	const handleRefresh = () => {
		refetch();
	};

	return (
		<Stack
			p="sm"
			w="100%"
			mih="100vh"
			sx={{
				overflowX: 'scroll',
			}}
		>
			<Group position="apart">
				<Button onClick={handleRefresh}>Refresh</Button>
			</Group>

			{automations.length === 0 && !isLoading && (
				<Group p="md">
					<Text>No active automations found in the queue.</Text>
				</Group>
			)}

			{totalAutomations > automations.length && (
				<Text size="sm" color="text/secondary/default" pb="md">
					Showing latest {automations.length} out of {totalAutomations} total
					automations
				</Text>
			)}

			{automations.map((automation) => (
				<AutomationCard
					key={automation.id}
					automation={automation}
					onRefresh={handleRefresh}
				/>
			))}
		</Stack>
	);
}

export default AdminAutomationsPage;
